import Axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';
let vue = new Vue;
let router = new VueRouter();
//import {
//	accountApiURL
//} from './../config/js/setConfig.js';
import {
	setCookie,
	getCookie,
	delCookie
} from './../config/js/handleCookie.js'


let base = '';

base = '//account.originoo.com/';
//base = '//192.168.1.241:8070/';
let axios = Axios.create({
	//	 headers: {'Content-Type': 'application/json'},
	baseURL: base
});

//请求
//axios.interceptors.request.use(
//config => {
//  return config;
//},
//err => {
//  return Promise.reject(err);
//});

//请求
axios.interceptors.request.use(
	config => {
		let token = getCookie('token');
		if(token) {
			//		 	config.headers.token = token;
			config.headers['originoo-authorization'] = token;
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	});

//响应
axios.interceptors.response.use(
	response => {
		if(response.status == 200) {

		} else {
			vue.$message.error(response.data.message)
		}
		return response;
	},
	error => {
		//console.log(error, 'error');

		
		//console.log(error.config, 'error.config')
		//console.log(error.response, 'error.response')
		if(error.response) {
			if(error.response.status == 500){
				if((error.response.request.responseURL).indexOf('account/refreshToken')>0){
					delCookie('token')
//					vue.$message.error('请登录')
				}else{
					vue.$message.error(error.response.data.message)
				}
			}else{
				vue.$message.error(error.response.data.message)
			}
		} else {
			vue.$message.error(error.message)
		}
		return Promise.reject(error);
	});

/* API命名格式 */
/**
 *  请求方式 + 自定义名 + 请求类型 （例. getCourseList）
 *  请求方式：get请求为get，post请求为post
 *  自定义名：根据情况自己定义(最好使用接口名)
 *  请求类型：获取列表跟List，添加跟Add, 编辑跟Update，删除跟Delete
 */

//get请求
//export const getLectureList = params => {
//var token = getToken();//微信获取token
//return axios.get(`${admin}user/getLecturers?token=${token}`, {params})
//}
//post请求
//export const postAddTrainingNeeds = params => {
//var token = getToken();
//return axios.post(admin + `trainingDemand/store?token=${token}`, params)
//}
//delete请求
//export const deleteTrainingNeeds = params => {
//var token = getToken();
//return axios.delete( `trainingDemand/delete/${params.id}`, {params})
//}

//function getToken() {
//	var token = '';
//	var user = localStorage.getItem('user');
//	user = JSON.parse(user);
//	if(user) {
//		token = user.token;
//	}
//	return token;
//}

//account.originoo.com/account/refreshToken
//登录
export const postAccountLogin = params => {
	return axios.post(`login`, params)
}

//刷新token

export const refreshToken = params => {
	return axios.get(`account/refreshToken`, {
		params
	})
}


//获取手机验证码
//export const getPhoneCode = params => {
//	return axios.post(`register/sendSmsCode`, params)
//}

export const getPhoneCode = params => {
	return axios.post(`register/sendSmsCode?imageCode=${params.imageCode}&telNum=${params.telNum}&token=${params.token}`, params)
}
//忘记密码

export const postForgetPassword = params => {
	return axios.post(`register/forgetPassword`, params)
}
//注册手机账号
//export const postRegAccount = params => {
//	return axios.post(`register`, params)
//}

export const postRegAccount = params => {
	return axios.post(`register?telNum=${params.telNum}&smsCode=${params.smsCode}&password=${params.password}`, params)
}


//params.telNum = this.reg_phone;
//				params.smsCode = this.reg_phoneCode;
//				params.password = this.reg_password;


// WEBPACK FOOTER //
// ./src/api/accountapi.js